import { createFileRoute } from "@tanstack/react-router";
import EncoderDecoderPage from "@/pages/EncoderDecoderPage";

export const Route = createFileRoute("/tools/encoder-decoder")({
  component: EncoderDecoderPage,
});
